import {useLocale, useUniversalFetch} from '#imports';

type CountryResource = {
    code: string;
    label: string;
};

/**
 * Returns the country label in the current locale.
 */
export function useCountryLabel() {
    const locale = useLocale();

    async function getCountryLabel(countryCode: string): Promise<string> {
        try {
            const regionNames = new Intl.DisplayNames(locale.languageCode.value, {type: 'region'});
            return regionNames.of(countryCode) ?? countryCode;
        } catch (_) {
            try {
                const country = await useUniversalFetch<CountryResource>(`/api/countries/${countryCode}`);
                return country.label;
            } catch (_) {
                return countryCode;
            }
        }
    }
    return {
        getCountryLabel,
    };
}
